import enUS from './en-US';
import frCA from './fr-CA';

export default {
  'en-US': enUS,
  'fr-CA': frCA
};
